export class TranscriptFetchError extends Error {
  status?: number;

  constructor(message: string, status?: number) {
    super(message);
    this.name = 'TranscriptFetchError';
    this.status = status;
  }
}
